import initDatepicker from './initDatepicker';

export default initDatepicker;



// WEBPACK FOOTER //
// ./scripts/lib/datepicker/index.js